/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, parseTimeString } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './ProBookableSlots.css';
import Loading from './Loading';

import {
  listBookableSlots,
} from '../../actions';


class ProBookableSlots extends Component {

  state = {};

  componentDidMount() {
    let params = this.listParams();
    this.setState({ loading: true });
    this.props.listBookableSlots(params, { silent: true })
      .then(resp => {
        this.setState({ loading: false });
      });
  }

  listParams() {
    let params = {};
    if (this.props.roomId) {
      params.schedule__room_id = this.props.roomId;
    }
    return params;
  }

  refreshBookableSlots() {
    let params = this.listParams();
    this.props.listBookableSlots(params, { background: true });
  }

  renderBookableSlots() {
    let bookableSlots = this.props.bookableSlots;
    if (!bookableSlots) return;

    let items = bookableSlots.items.sort((a, b) => {
      return a.datetime.localeCompare(b.datetime);
    });

    let byDate = {};
    for (let bs of items) {
      let key = moment(bs.datetime).format('YYYY-MM-DD');
      if (!byDate[key]) {
        byDate[key] = [];
      }
      byDate[key].push(bs);
    }

    let dates = Object.keys(byDate);
    let nodes = [];
    for (let date of dates) {
      let dateNodes = [];
      for (let bs of byDate[date]) {
        let m = moment(bs.datetime);
        let dateNode = (
          <Link key={bs.id} to={'/pro/bookings/' + bs.id} className="bookable-slot">
            <div className="time">{bs.prettyStart}-{bs.prettyEnd}</div>
            <div className="room">{bs.room.name}</div>
            <div className="workflow">{bs.workflow} ({bs.slotsBooked}/{bs.totalSlots} booked)</div>
          </Link>
        );
        dateNodes.push(dateNode);
      }
      let dateMoment = moment(date, 'YYYY-MM-DD');
      let node = (
        <div key={date} className="bookable-slots-date">
          <div className="bookable-slots-date-header">
            <b>{dateMoment.format('dddd')}</b>
            {dateMoment.format('MMM Do')}
          </div>
          <div className="bookable-slots">{dateNodes}</div>
        </div>
      );
      nodes.push(node);
    }

    return (
      <div className="bookable-slots-wrapper">
        <div className="bookable-slots-header">
          <div className="controls">
            <Button onClick={() => this.refreshBookableSlots()}>Refresh</Button>
          </div>
        </div>
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <div className="ProBookableSlots">
        {this.state.loading && <Loading />}
        {!this.state.loading && this.renderBookableSlots()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookableSlots: state.list.bookableSlot,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listBookableSlots,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProBookableSlots);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ProBookableSlots.js
 **/